import { Modal, ModalBody, Spinner } from "reactstrap";
import ErrorMessage from "./ErrorMessage";
import { useState } from "react";
import CrossIcon from "../Icons/CrossIcon";
import CheckIcon from "../Icons/CheckIcon";

const ApproveRejectModal = ({
  modal,
  toggle,
  submitHandler,
  isLoading,
  actionType, // "approve", "reject", "shortClose"
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (actionType === "reject" || actionType === "shortClose") {
      if (!reason.trim()) {
        setError("Reason is required");
        return;
      }
      submitHandler(reason);
    } else {
      submitHandler();
    }
  };

  const closeHandler = () => {
    setReason("");
    setError("");
    toggle();
  };

  const isRejectOrShortClose = actionType === "reject" || actionType === "shortClose";

  return (
    <Modal isOpen={modal} toggle={closeHandler} centered>
      <ModalBody className="text-center">
        <div className="d-flex flex-column justify-content-center align-items-center gap-4">
          <span className={isRejectOrShortClose ? "icon" : "icon success"}>
            {isRejectOrShortClose ? <CrossIcon /> : <CheckIcon />}
          </span>
          {actionType === "shortClose" ? (
            <p className="mb-4">Do you really want to short close ?</p>
          ) : (
            <p className="mb-4">
              Do you really want to {actionType === "reject" ? "Reject" : "Approve"} this request?
            </p>
          )}

          {isRejectOrShortClose && (
            <div className="col-12">
              <div className="d-flex flex-column">
                <label htmlFor="reasonInput" className="form-label text-start">
                  {actionType === "shortClose" ? "Short Close Reason" : "Reason"} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control w-100"
                  placeholder={actionType === "shortClose" ? "Enter short close reason" : "Enter rejection reason"}
                  id="reasonInput"
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                    setError("");
                  }}
                />
                <ErrorMessage message={error} />
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="row m-0 w-100">
            <div className="col-12 col-md-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={closeHandler}
              >
                Cancel
              </button>
            </div>
            <div className="col-12 col-md-6 pe-0 ps-3">
              <button
                className={`btn ${isRejectOrShortClose ? "btn-danger" : "btn-success"} w-100`}
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner />
                ) : actionType === "shortClose" ? (
                  "Short Close"
                ) : actionType === "reject" ? (
                  "Reject"
                ) : (
                  "Approve"
                )}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ApproveRejectModal;
